import { Div } from '../../../base/components/native/div'
import { Span } from '../../../base/components/native/span'

export const NotSure = () => {

    const base = Div()
    const first = Span('Not sure, use our ')
    const second = Span('digital assistent')
    base.append(first, second)

    second.cssClass({
        textDecoration: 'underline',
        cursor: 'pointer',
    })
    base.cssClass({
        color: '#fff',
        fontSize: '18px',
        fontWeight: '400',
        width: '100%',
        textAlign: 'center',
        paddingBottom: '90px',
    })

    return base
}